import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { Typography } from '@monorepo/nova-ui';
import { KYC_VERIFICATION_CONSTANTS } from '../constants';
import {
  KycContentContainer,
  KycDescriptionText,
  KycIconTitleContainer,
} from '../styled';

export const KycContent: FC = () => {
  const { t } = useTranslation('profile');

  return (
    <KycContentContainer gap={2} justifyContent="space-between">
      <KycIconTitleContainer>
        <SystemIcon
          iconName="Warning"
          size={KYC_VERIFICATION_CONSTANTS.UI.ICON_SIZE}
        />
        <Typography variant="subtitle2">
          {t(KYC_VERIFICATION_CONSTANTS.TRANSLATION_KEYS.TITLE)}
        </Typography>
      </KycIconTitleContainer>

      <KycDescriptionText>
        <Typography
          variant="subtitle2"
          sx={(theme) => ({ fontWeight: theme.typography.fontWeightLight })}
        >
          {t(KYC_VERIFICATION_CONSTANTS.TRANSLATION_KEYS.DESCRIPTION)}
        </Typography>
      </KycDescriptionText>
    </KycContentContainer>
  );
};
